import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import assetUpdaters from '@/api/updaters/content-studio/asset';
import {CONTENT_LAB, ASSETS, FOLDERS} from '../../consts';

function useDeleteAsset({
  onMutate,
  onError,
  onSuccess,
}: {
  onSuccess?: (data: unknown) => void;
  onMutate?: (assetIds: string[]) => void;
  onError?: (error: unknown, variables: unknown, context: unknown) => void;
} = {}) {
  return useMutation({
    mutationFn: (assetIds: string[]) => assetUpdaters.archiveAssets(assetIds),
    onMutate,
    onError,
    onSuccess:
      onSuccess ||
      (() => {
        queryClient.invalidateQueries({queryKey: [CONTENT_LAB, ASSETS]});
        queryClient.invalidateQueries({queryKey: [CONTENT_LAB, FOLDERS]});
      }),
  });
}

export default useDeleteAsset;
